import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { init as initErrorTracking } from "@adhawk/error-tracking";
import { ErrorBoundary } from "@adhawk/react-error-boundary";

initErrorTracking({
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  environment:
    process.env.REACT_APP_RELEASE_ENVIRONMENT || process.env.NODE_ENV,
  release: process.env.REACT_APP_RELEASE_VERSION
});

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);
